import React, { Component } from 'react';
import { Container, Popover, Button, TextField, Box, Typography } from '@material-ui/core'

import { Currency } from 'react-frontend-utils'



export default class ReturnRefundPopover extends Component {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
            marginBottom: 10
        }
    };

 
    _okCallback;
    _cancelCallback;
    
    state = {
        amount: null,
        commentEntry: null
    }
    
    constructor(props) {
        super(props);
        this._okCallback = props.okCallback;
        this._cancelCallback = props.cancelCallback;
        this._maxChars = props.maxChars ? props.maxChars : 1024;
    }
   
    _numberFieldChanged = (event) => {
        let val;
        
        if (this.props.forReturn) {
            val = parseInt(event.target.value);
            if (val < 1)
                val = 1;
        }
        else {
            val = parseFloat(event.target.value);
            
            if (val <= 0)
                val = this.props.maxVal;            
        }
        if (val > this.props.maxVal)
            val = this.props.maxVal;
        
        this.setState({amount: val});
    }
    
    _commentFieldChanged = (event) => {
        let val = event.target.value;
        this.setState({commentEntry: val});
    }
    
    
    _okButtonPressed = () => {

        let val = this.state.amount;  
        if (val === null)  //never changed
            val = this.props.maxVal;
            

        const comment = this.state.commentEntry;
        
        this._okCallback(val, comment);
        this.setState({amount: null, commentEntry: null});  //clear text for next time
    }
    
    _cancelButtonPressed = () => {
        this._cancelCallback();
        this.setState({amount: null, commentEntry: null});  //clear text for next time
    }
    
    
    render() {
        
        let maxWidth = window.innerWidth * 0.5;  //half the window, up to 350
        if (maxWidth > 700)
            maxWidth = 700;
        
        
        const title = this.props.forReturn ? "Return Purchase/Redemption" : "Refund";
        const valTitle = this.props.forReturn ? "Quantity" : "Amount";
         
        const max = this.props.forReturn ? this.props.maxVal : Number(Currency.round(this.props.maxVal)); 
         
        let val = this.state.amount === null ? max : this.state.amount;
         
        return (
            <Popover open={this.props.isOpen} 
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}  >
                
                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>{title}</Typography>  
                    <div style={{marginTop: 20}}/>

                    <Container style={this.styles.container}>    
                        <TextField label={valTitle} type="number" value={val} onChange={this._numberFieldChanged} variant="outlined" fullWidth={false} InputLabelProps={{ shrink: true}} />
                    </Container>

                    <TextField label="Reason/Comment" autoFocus multiline={true} rows={5} value={this.state.commentEntry} onChange={this._commentFieldChanged} variant="outlined" fullWidth={true} inputProps={{maxLength: this._maxChars}} InputLabelProps={{ shrink: true}} />
        
                    <Container style={this.styles.container}>    
                        <Button onClick={this._okButtonPressed} disabled={!val} color="primary" variant="outlined" style={this.styles.button}>OK</Button>
                        <Button onClick={this._cancelButtonPressed} variant="outlined" style={this.styles.button}>Cancel</Button>
                    </Container>
                </Box>
            </Popover>
        );
        
        
    }


}